package com.neurobs.react.semanticui

import com.neurobs.react.{ReactUtil, StyleUtil}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.html._

object UiIconFactory {

  private def TemplateIcon(iconName: String)(uiElementModifiers: UiElementModifiers) = {
    val (iconModifiers, classString, _) = uiElementModifiers.values
    i(
      className := s"$iconModifiers $iconName icon $classString",
      style := uiElementModifiers.createStyle
    )()
  }

  def Icon(iconName: String)(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateIcon(iconName)(uiElementModifiers)
  }

}

